import { ChevronDown20, ChevronRight20 } from '@carbon/icons-react';
import React from 'react';
import isEqual from 'react-fast-compare';
import cx from 'classnames';
export var isMobileView = function (DefaultWindowWidth, width) {
    return width && width < DefaultWindowWidth;
};
export var pickProperNodeIcon = function (selectedParentToExpand, currentCode, isSearchHasPhrase, childrenLength) {
    if (isSearchHasPhrase || childrenLength === 0) {
        return React.createElement("div", { style: { width: '18px' } });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ChevronDown20, { className: cx(!selectedParentToExpand.includes(currentCode) && 'hidden'), style: { width: '18px', height: '18px', fontSize: '18px' } }),
        React.createElement(ChevronRight20, { className: cx(selectedParentToExpand.includes(currentCode) && 'hidden'), style: { width: '18px', height: '18px', fontSize: '18px' } })));
};
// based on the use-deep-compare lib https://github.com/sandiiarov/use-deep-compare/blob/9649e7cceb507ede8beadec9f3797d8582a906eb/src/useDeepCompareMemoize.ts#L14
export function useDeepCompareMemo(value) {
    var ref = React.useRef([]);
    if (!isEqual(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
export function prepareCodesToRender(cpvCodes, searchValue, codesWithParents, selectedParentToExpand) {
    if (searchValue) {
        Object.keys(cpvCodes)
            .sort(function (a, b) { return a.localeCompare(b); })
            .filter(function (code) {
            return code.includes(searchValue) ||
                cpvCodes[code].description
                    .toLowerCase()
                    .includes(searchValue);
        })
            .forEach(function (code) {
            codesWithParents.add(code);
            cpvCodes[code].parents.forEach(function (parentCode) {
                codesWithParents.add(parentCode);
            });
        });
        return Array.from(codesWithParents).sort(function (a, b) { return a.localeCompare(b); });
    }
    return Object.keys(cpvCodes)
        .sort(function (a, b) { return a.localeCompare(b); })
        .filter(function (code) {
        return cpvCodes[code].parents.length === 0 ||
            cpvCodes[code].parents.every(function (parentCode) {
                return selectedParentToExpand.includes(parentCode);
            });
    });
}
